// app_client/src/components/common/DataTable.jsx
import React from 'react';

const DataTable = ({ columns, data, loading, error, emptyText = 'Kayıt bulunamadı' }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-left">
      <thead className="bg-slate-50/80">
        <tr>
          {columns.map((column) => (
            <th
              key={column.key}
              className={`border-b border-slate-100 p-5 text-[10px] font-black uppercase tracking-widest text-slate-400 ${column.headerClassName || ''}`}
            >
              {column.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-50">
        {loading ? (
          <tr>
            <td colSpan={columns.length} className="p-16 text-center text-sm font-black text-slate-400">
              Yükleniyor...
            </td>
          </tr>
        ) : error ? (
          <tr>
            <td colSpan={columns.length} className="p-16 text-center text-sm font-black text-rose-600">
              {error}
            </td>
          </tr>
        ) : data.length === 0 ? (
          <tr>
            <td colSpan={columns.length} className="p-16 text-center text-xs font-black uppercase tracking-widest text-slate-400">
              {emptyText}
            </td>
          </tr>
        ) : (
          data.map((row) => (
            <tr key={row._id} className="transition-colors hover:bg-slate-50/80">
              {columns.map((column) => (
                <td key={column.key} className={`p-5 ${column.cellClassName || ''}`}>
                  {column.render ? column.render(row) : row[column.key]}
                </td>
              ))}
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

export default DataTable;
